/**
 * US ZIP helpers for billing address.
 *
 * Street autocomplete (Google Places) can plug in when
 * REACT_APP_GOOGLE_MAPS_API_KEY is set. Until then, ZIP fills city/state.
 */

export const US_ZIP5_RE = /^\d{5}$/;

/**
 * Normalize a US ZIP to 5 digits, or null.
 *
 * @param {string} postal
 * @returns {string|null}
 */
export const normalizeUsZip5 = postal => {
  const zip = String(postal || '').replace(/\D/g, '').slice(0, 5);
  return US_ZIP5_RE.test(zip) ? zip : null;
};

/**
 * True when Google Places street autocomplete can be wired.
 *
 * @returns {boolean}
 */
export const hasStreetAutocomplete = () =>
  typeof process !== 'undefined' && !!process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/**
 * Map a Zippopotam /api/us-zip payload to form fields.
 *
 * @param {Object} payload
 * @returns {{ city: string, state: string, country: string, postal: string }|null}
 */
export const cityStateFromUsZipPayload = payload => {
  if (!payload?.city || !payload?.state) {
    return null;
  }
  return {
    city: payload.city,
    state: payload.state,
    country: payload.country || 'US',
    postal: payload.postal || '',
  };
};
